import { type FC, memo } from 'react';

interface ISliderHeaderProps {
  title: string;
  icon?: React.ReactElement;
}

/**
 * Header component for the games slider
 * Displays title with optional icon
 */
export const SliderHeader: FC<ISliderHeaderProps> = memo(({ title, icon }) => (
  <div className="title">
    {title}
    {icon && <span className="icon">{icon}</span>}
  </div>
));
